import Button from "../Buttons"
import AutomateFeatureImage from "../../assets/images/automate_feature_image.png"
import AutomateIcon from "../../assets/icons/automate_icon.svg"
import React from "react"

interface AutomateProps {
  journeyHandler: () => void
}

const AutomateHiring: React.FC<AutomateProps> = ({
  journeyHandler
})=>{
    return (
        <section id="start_your_journey" className="layout-container lg:!px-40 !py-[25px] lg:!py-20 bg-[#F5F6F7] relative grid grid-cols-1 lg:grid-cols-2 gap-10 items-end justify-between">

              <img
                src={AutomateFeatureImage}
                alt="feature_image"
                className="w-full h-full object-cover" 
              />
            <div className="flex lg:flex-col lg:items-end">
              <div className="mb-5 hidden lg:block">
                <img
                  src={AutomateIcon}
                  alt="feature_icon"
                />
              </div>
              <div className="bg-white p-6 mt-[-15px] lg:mt-0 rounded-3xl">
                <h2 className="font-semibold text-[28px] lg:text-[48px] leading-tight mb-6">Automate your
                  recruitment workflow
                  with TalentHub.</h2>
                <p>Put your recruitment efforts on auto-pilot with TalentHub</p>
                <div className="mt-6">
                  <Button
                    btn_label="Start your journey"
                    on_click_handler={journeyHandler}
                    other_classes="!bg-[#23FF9C] !text-[#232323] !text-[14px]"
                  />
                </div>
              </div>
            </div>
          </section>
    )
}

export default AutomateHiring;